import { ReactNode, useCallback } from "react"
import { pushToast as pushToastAction } from "../../redux/slices/notifications"
import { ToastTheme } from "../../types"
import { useAppDispatch } from "./use-store"

export const useToast = () => {
  const dispatch = useAppDispatch()

  const dispatchPushToast = useCallback(
    (msg: ReactNode, theme: ToastTheme) => {
      dispatch(
        pushToastAction({
          msg: msg,
          theme: theme,
          timeout: 3000
        })
      )
    },
    [dispatch]
  )

  const pushSuccessToast = useCallback(
    (msg: ReactNode) => {
      dispatchPushToast(msg, "success")
    },
    [dispatchPushToast]
  )

  const pushErrorToast = useCallback(
    (msg: ReactNode) => {
      dispatchPushToast(msg, "danger")
    },
    [dispatchPushToast]
  )

  const pushToast = useCallback(
    (msg: ReactNode) => {
      dispatchPushToast(msg, "danger")
    },
    [dispatchPushToast]
  )

  return {
    pushSuccessToast,
    pushErrorToast,
    pushToast
  }
}
